import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout shell for `/metric-hub/drafts/<slug>/<draftId>` and its children.
 *
 * Two leaves live underneath:
 *  - `drafts.$slug.$draftId.index.tsx`  → URL `/.../<draftId>`  (read view)
 *  - `drafts.$slug.$draftId.edit.tsx`   → URL `/.../<draftId>/edit` (full editor)
 *
 * The shell only renders an `<Outlet />` so the active leaf takes the
 * whole frame. Without it, the `/edit` URL would mount the edit route
 * but the parent (the read DraftPage) would still be on screen — the
 * original "Open Draft no sale nada" bug played in reverse: edit URL
 * reached but only the read view rendered.
 *
 * URL: `/metric-hub/drafts/<slug>/<draftId>(/edit)`. Deliberately uses
 * a `drafts.$slug.$draftId` filename (not `metrics.$slug.drafts.$draftId`)
 * so TanStack Router does NOT auto-nest under `metrics.$slug` — sharing
 * the prefix would force the draft view inside MetricDetailPage's
 * (nonexistent) Outlet.
 */
export const Route = createFileRoute('/_authed/metric-hub/drafts/$slug/$draftId')({
  component: DraftLayout,
});

function DraftLayout() {
  return <Outlet />;
}
